/* tslint:disable */
/* eslint-disable */
/**
 * Activity Feed API
 * API for managing activity feed entries including historical events, actions, and notifications.  The activity feed provides a unified timeline of events and actions for insured risks (risques assurés). It supports notifications with read/unread status tracking and badge count for UI display.  ## Entry Types - **Historique**: Historical events (e.g., mandate signed, document uploaded) - **Action**: Actionable items with due dates (e.g., pending approvals, required follow-ups)  ## Sources - **Internal**: Events generated by the platform - **External**: Events from external systems or user actions  ## Entity Links Messages can contain entity references in the format `{EntityType:Guid}` which are resolved using the `entities` array for navigation purposes. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Priority level for history events
 * @export
 */
export const HistoryPriorityEnum = {
    Low: 'Low',
    Normal: 'Normal',
    High: 'High',
    Urgent: 'Urgent'
} as const;
export type HistoryPriorityEnum = typeof HistoryPriorityEnum[keyof typeof HistoryPriorityEnum];


export function instanceOfHistoryPriorityEnum(value: any): boolean {
    for (const key in HistoryPriorityEnum) {
        if (Object.prototype.hasOwnProperty.call(HistoryPriorityEnum, key)) {
            if (HistoryPriorityEnum[key as keyof typeof HistoryPriorityEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function HistoryPriorityEnumFromJSON(json: any): HistoryPriorityEnum {
    return HistoryPriorityEnumFromJSONTyped(json, false);
}

export function HistoryPriorityEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoryPriorityEnum {
    return json as HistoryPriorityEnum;
}

export function HistoryPriorityEnumToJSON(value?: HistoryPriorityEnum | null): any {
    return value as any;
}

export function HistoryPriorityEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): HistoryPriorityEnum {
    return value as HistoryPriorityEnum;
}

